
import {tap, filter, withLatestFrom, map, switchMap, take} from 'rxjs/operators';
/**
 * Created by christiancueni on 02/08/16.
 * Copyright (c) 2016 ITerativ GmbH. All rights reserved.
 */



import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { AppActionTypes } from './app.actions';
import { NotificationsIntervalService } from '../notifications/notifications-interval.service';
import * as reducers from "../reducers";
import { Store } from '@ngrx/store';
import { AppState } from '../reducers';
import { StartInterval } from '../notifications/notifications.actions';
import { CustomAction } from '../actions/CustomAction';
import { HelloClassApiService } from '../services';
import { PushRegistration } from './app.models';

@Injectable()
export class AppEffects {

    constructor(private store:Store<AppState>,
                private actions$: Actions,
                private notificationIntervalService:NotificationsIntervalService,
                private helloclassApi: HelloClassApiService) {}

     isOffline$ = createEffect(() => this.actions$.pipe(
        ofType(AppActionTypes.APP_SET_OFFLINE),
        map(() => {
            this.notificationIntervalService.stopInterval();
            return { type: 'NOP', payload: null };
        })));

     isOnline$ = createEffect(() => this.actions$.pipe(
        ofType(AppActionTypes.APP_SET_ONLINE),
        withLatestFrom(
            this.store.select(reducers.getAppPush),
            this.store.select(reducers.getAuthAnonymous)),
        filter(data => !data[1] && !data[2]), // no push for app
        tap(() => this.store.dispatch(new StartInterval())),
        map(() =>  ({ type: 'NOP', payload: null })),));

     setPushId$ = createEffect(() => this.actions$.pipe(
        ofType(AppActionTypes.APP_SET_PUSH_ID),
        map((action:CustomAction) => action.payload),
        switchMap((pushId: PushRegistration) => this.helloclassApi.setPushId(pushId.registrationId, pushId.name, pushId.uuid).pipe(
                take(1),
                map(() => ({ type: 'NOP', payload: null })))
        )
    ));
}
